export default class ImagePreviewModel  {
	ImageUrl? = '';
	Width: number;
	Height: number;
	Top: number;
	Left: number;
}



// WEBPACK FOOTER //
// ./~/ui-components/~/crop-image/src/ImagePreviewModel.ts